import React from "react";

export const DetailsModal = ({
  modal,
  onClose,
  showInDollars,
  getMoneda,
  localString,
  pais,
  tipoCambioActual,
  styles,
}) => {
  if (!modal.open) return null;

  const rate = showInDollars ? tipoCambioActual || 1 : 1;
  const soloCarteleria = modal.items.every((op) => op.esCarteleria);

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h5>{modal.title}</h5>
          <button type="button" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className={styles.modalBody}>
          {modal.items.length === 0 ? (
            <p className={styles.noData}>No hay oportunidades</p>
          ) : (
            <table className={styles.modalTable} style={{ width: "100%", tableLayout: "fixed" }}>
              <thead>
                <tr>
                  <th style={{ width: "15%" }}>Tipo</th>
                  <th style={{ width: soloCarteleria ? "45%" : "30%" }} className="text-start">
                    Cliente
                  </th>
                  <th style={{ width: "20%" }} className="text-end">
                    Monto
                  </th>
                  {!soloCarteleria && <th style={{ width: "20%" }}>Detalle</th>}
                  <th style={{ width: "20%" }}>Mes</th>
                </tr>
              </thead>
              <tbody>
                {modal.items.map((op) => {
                  // Determinar tipo y badge
                  let tipoLabel = "PAUTA";
                  let badgeClass = "bg-primary";
                  if (op.esBTL) {
                    tipoLabel = "BTL";
                    badgeClass = "bg-success";
                  } else if (op.esHardware) {
                    tipoLabel = "HARDWARE";
                    badgeClass = "bg-warning text-dark";
                  } else if (op.esCarteleria) {
                    tipoLabel = "CARTELERÍA";
                    badgeClass = "bg-info";
                  } else if (op.esContrato) {
                    tipoLabel = "PAUTA";
                    badgeClass = "bg-primary";
                  }

                  // Detalle contextual
                  let detalle = "-";
                  if (op.esBTL || (!op.esHardware && !op.esCarteleria)) {
                    detalle = op.ejecutivo || "-";
                  } else if (op.esHardware) {
                    detalle = op.modalidad || "CAPEX";
                  } else if (op.esCarteleria) {
                    detalle = `${op.pantallas || 1} pant.`;
                  }

                  // Fecha/mes
                  let mesDisplay = "-";
                  if (op.mes_factura || op.mes_cierre) {
                    mesDisplay = op.mes_factura || op.mes_cierre;
                  } else if (op.fecha_cierre) {
                    const fecha = new Date(op.fecha_cierre);
                    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
                    mesDisplay = `${mes}-${fecha.getFullYear()}`;
                  } else if (op.fecha_inicio) {
                    const fecha = new Date(op.fecha_inicio);
                    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
                    mesDisplay = `${mes}-${fecha.getFullYear()}`;
                  }

                  // Monto a mostrar
                  let montoDisplay;
                  let monedaDisplay;
                  if (op.esHardware && op.esMonedaUF && op.importeOriginal !== undefined) {
                    montoDisplay = op.importeOriginal.toLocaleString("es-CL", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    });
                    monedaDisplay = "UF ";
                  } else {
                    const monto = showInDollars
                      ? (op.importe || op.total_investment || 0) / rate
                      : op.importe || op.total_investment || 0;
                    montoDisplay = monto.toLocaleString(showInDollars ? "en-US" : localString(pais), {
                      maximumFractionDigits: 0,
                    });
                    monedaDisplay = getMoneda();
                  }

                  return (
                    <tr key={op.id}>
                      <td>
                        <span className={`badge ${badgeClass}`}>{tipoLabel}</span>
                      </td>
                      <td className="text-start">{op.cliente}</td>
                      <td className="text-end">
                        {monedaDisplay}
                        {montoDisplay}
                      </td>
                      {!soloCarteleria && <td>{detalle}</td>}
                      <td>{mesDisplay}</td>
                    </tr>
                  );
                })}
                {modal.items.length > 0 && (
                  <tr className="table-dark fw-bold">
                    <td colSpan={2} className="text-start">
                      TOTAL
                    </td>
                    <td className="text-end">
                      {getMoneda()}
                      {modal.items
                        .reduce(
                          (sum, op) =>
                            sum +
                            (showInDollars
                              ? (op.importe || op.total_investment || 0) / rate
                              : op.importe || op.total_investment || 0),
                          0
                        )
                        .toLocaleString(showInDollars ? "en-US" : localString(pais), {
                          maximumFractionDigits: 0,
                        })}
                    </td>
                    <td colSpan={soloCarteleria ? 1 : 2} />
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </div>
        <div className={styles.modalFooter}>
          <button onClick={onClose}>Cerrar</button>
        </div>
      </div>
    </div>
  );
};
